import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,{attrs:{"dense":""}},[_c(VListItemContent,{class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.permission.name)+" ")]),_c(VListItemContent,[_c(VSwitch,{attrs:{"dense":""},model:{value:(_vm.permission.isActive),callback:function ($$v) {_vm.$set(_vm.permission, "isActive", $$v)},expression:"permission.isActive"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }